import noop from 'lodash/noop';
import { createContext, useContext } from 'react';

import { ProductTypes, TakeoverType } from '~src/model';

export interface SelectedProductTypeContext {
  selectedProductTypes: ProductTypes;
  setSelectedProductTypes: (value: ProductTypes) => void;
  disabledProducts?: ProductTypes;
  takeover?: TakeoverType;
}

const selectedProductTypeContext = createContext<SelectedProductTypeContext>({
  selectedProductTypes: [],
  setSelectedProductTypes: () => noop,
  disabledProducts: [],
  takeover: undefined,
});

export const useSelectedProductTypesContext = () => useContext<SelectedProductTypeContext>(selectedProductTypeContext);

export const SelectedProductTypeContextProvider = selectedProductTypeContext.Provider;
